import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles(({ colors }: Theme) => createStyles({
  label: {
    marginBottom: 5,
  },
  selectWrapper: {
    width: '100%',
    padding: 0,
    marginBottom: 10,
    '& .Mui-focused fieldset': {
      borderColor: '#01b3c5 !important',
    },
  },
  select: {
    padding: 4,
    fontWeight: 300,
    border: `2px solid ${colors.border}`,
    fontSize: 14,
    lineHeight: '16px',
    fontFamily: 'Montserrat, sans',
  },
  formControl: {

  },
}));

export default useStyles;
